import React, { Component } from 'react'
import { get } from 'lodash'
import { apiCommon } from 'helpers/decorators/api'
import appConfig from 'config'

@apiCommon({
  version: true
})
class Footer extends Component {
  render() {
    return (
      <footer style={{ fontSize: 14, padding: 4 }}>
        <div>
          API version:{' '}
          <strong>{get(this.props, 'common.version.detail.version')}</strong>
        </div>
        <div>
          BO version: <strong>{appConfig.version}</strong>
        </div>
      </footer>
    )
  }
}

export default Footer
